import axios from 'axios';
import { environment } from '../environment/environment';

export interface UserTAAssignment {
  ta_role_id: string | null;
  site_ids: string[];
  site_group_ids: string[];
  receive_no_clockin_digest?: boolean;
}

const BASE_URL = `${environment.baseUrl}/users`;

async function getAssignment(userId: number | string): Promise<UserTAAssignment> {
  const response = await axios.get<UserTAAssignment>(
    `${BASE_URL}/${userId}/ta-assignment/`,
  );
  return response.data;
}

async function setAssignment(
  userId: number | string,
  payload: UserTAAssignment,
): Promise<UserTAAssignment> {
  const response = await axios.put<UserTAAssignment>(
    `${BASE_URL}/${userId}/ta-assignment/`,
    payload,
  );
  return response.data;
}

export const userTAAssignmentApiService = {
  getAssignment,
  setAssignment,
};
